<template>
  <div class="login-container">
    <!-- Titlebar
================================================== -->
    <div id="titlebar" class="gradient">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2>Log In</h2>

            <!-- Breadcrumbs -->
            <nav id="breadcrumbs" class="dark">
              <ul>
                <li><router-link tag="a" to="/" href="#">Home</router-link></li>
                <li>Log In</li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>

    <!-- Page Content
================================================== -->
    <div class="container">
      <div class="row">
        <div class="col-xl-5 offset-xl-3">
          <div class="login-register-page">
            <!-- Welcome Text -->
            <div class="welcome-text">
              <h3>We're glad to see you again!</h3>
              <span
                >Don't have an account?
                <router-link tag="a" to="/register"
                  >Sign Up!
                </router-link></span
              >
            </div>

            <!-- Form -->
            <form id="login-form">
              <div class="input-with-icon-left">
                <i class="icon-material-baseline-mail-outline"></i>
                <input
                  type="email"
                  class="input-text with-border"
                  name="emailaddress"
                  id="emailaddress"
                  placeholder="Email Address"
                  required
                  v-model="userData.email"
                />
              </div>

              <div class="input-with-icon-left">
                <i class="icon-material-outline-lock"></i>
                <input
                  type="password"
                  class="input-text with-border"
                  name="password"
                  id="password"
                  placeholder="Password"
                  required
                  v-model="userData.password"
                />
              </div>
              <router-link
                tag="a"
                to="/forgot-password"
                href="#"
                class="forgot-password"
                >Forgot Password?</router-link
              >
            </form>

            <!-- Error Message -->
            <div class="notification error closeable" v-if="errorMessage">
              <p v-text="errorMessage"></p>
            </div>

            <div class="notification success closeable" v-if="validToken">
              <p>
                Registration Successful, Kindly login here
              </p>
            </div>
            <!-- #Error Message -->

            <!-- Login Button -->
            <button
              class="
                button
                full-width
                button-sliding-icon
                ripple-effect
                margin-top-10
              "
              type="submit"
              @click="login()"
              :disabled="loginButtonDisabled"
            >
              Log In <i class="icon-material-outline-arrow-right-alt"></i>
            </button>
            <!-- #Login Button -->
          </div>
        </div>
      </div>
    </div>

    <!-- Spacer -->
    <div class="margin-top-70"></div>
    <!-- Spacer / End-->
  </div>
</template>

<script>
/* eslint-disable no-console */
import { postCall } from "../../../core/services/http.service";
import { LOGIN } from "../../../core/config/endpoints/auth";
import { setToken, storeUserData } from "../../../plugins/handlers";

export default {
  name: "Login",

  data() {
    return {
      errorMessage: null,
      loginButtonDisabled: false,
      token: "",
      userData: {
        email: "fred@gmail.com",
        password: "password",
      },
      user: {},
    };
  },

  computed: {
    validToken() {
      return !!this.$store.state.token;
    },
  },

  methods: {
    login() {
      if (this.userData.email.length < 5)
        return (this.errorMessage = "Provide a valid email");
      if (this.userData.password.length < 6)
        return (this.errorMessage = "Provide password");

      postCall(LOGIN, this.userData)
        .then(response => {
          this.token = response.data.data.token;
          this.user = response.data.data.user;
          setToken(this.token);
          storeUserData(this.user);
        })
        .catch(error => {
          if (!error.response) return "Try again";
          if (!error.response.data) return "Try again";
          this.errorMessage = error.response.data.message;
        })
        .finally(() => {
          if (!this.token) return false;

          let lastUrl = localStorage.getItem("from");
          if (lastUrl && lastUrl != "/login") {
            return this.$router.push(lastUrl);
          }

          return this.$router.push("/");
        });
    },
  },
};
</script>

<style scoped>
.login-container {
  min-height: 90vh;
}
</style>
